























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { RecognizeTable } from '../../api/common/index';
import { SaveFile } from '../../api/space/index';
import { downloadByUrl } from '@/utils/file.util';

@Component({
  components: {},
  filters: {},
})
export default class Index extends Vue {
  status = 'init'; // init   success  transform   finish
  uploadPlayload = {};
  acceptImgType = '.png,.jpg,.jpeg,.pdf';
  uploadServer = '';
  fileUrl = '';
  fileName = '';
  fileType = '';
  percent = 1;
  timer = null as any;
  transformUrl = '';
  mounted() {}
  handleTransform() {
    RecognizeTable({ file: this.fileUrl }).then(res => {
      this.status = 'transform';
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.percent++;
        if (this.percent == 99) {
          clearInterval(this.timer);
          this.status = 'finish';
        }
      }, 20);
      setTimeout(() => {
        if (res) {
          this.transformUrl = res;
          this.status = 'finish';
          clearInterval(this.timer);
        }
      }, 1000);
    });
  }

  changeFile(e: any) {
    const that = this;
    const files = e.target.files;
    console.log(files);
    that.fileUrl = files[0];
    that.fileType = files[0].type.split('/')[1];

    that.status = 'success';
    that.fileName = files[0].name.split('.')[0];
  }

  handleSave() {
    SaveFile({
      opType: 'upload',
      openState: 1,
      url: this.transformUrl,
      name: this.fileName + '.xslx',
      parentSn: '',
    }).then(res => {
      this.$message.success('保存成功');
    });
  }

  handleDownload() {
    downloadByUrl(this.transformUrl, this.fileName + '.xslx');
  }
}
